import { useEffect, useRef } from 'react';

const reviews = [
  {
    name: 'Ayşe Kaya',
    location: 'Kadıköy',
    date: 'Ocak 2025',
    service: 'Koltuk Yıkama',
    rating: 5,
    text: 'İnanılmaz sonuç! 5 yıllık koltukta 5 dakika içinde renk farkını gördüm. Ekip çok profesyoneldi, her adımı açıkladılar. Kesinlikle tavsiye ederim.',
    initials: 'AK',
    color: 'bg-emerald-500',
  },
  {
    name: 'Mehmet Yılmaz',
    location: 'Üsküdar',
    date: 'Aralık 2024',
    service: 'Petek Temizliği',
    rating: 5,
    text: 'Peteklerimiz hiç ısınmıyordu, faturalar had safhaya çıkmıştı. Temizlik sonrası odalar çok daha hızlı ısındı. Kombi filtresi dahil eksiksiz hizmet.',
    initials: 'MY',
    color: 'bg-blue-500',
  },
  {
    name: 'Fatma Demir',
    location: 'Maltepe',
    date: 'Şubat 2025',
    service: 'Yatak Yıkama',
    rating: 5,
    text: 'Çocuğumun yatağındaki sarı lekelerin büyük çoğunluğu çıktı. Bana leke konusunda dürüstçe bilgi verdiler, güven verdiler. Teşekkürler!',
    initials: 'FD',
    color: 'bg-purple-500',
  },
  {
    name: 'Ali Çelik',
    location: 'Ataşehir',
    date: 'Ocak 2025',
    service: 'Sandalye Yıkama',
    rating: 5,
    text: 'Yemek masası sandalyelerim 8 kişilik bir set, hepsini temizlediler. Koku tamamen gitti. Fiyat performans açısından mükemmel bir hizmet.',
    initials: 'AÇ',
    color: 'bg-orange-500',
  },
  {
    name: 'Zeynep Arslan',
    location: 'Beşiktaş',
    date: 'Kasım 2024',
    service: 'Koltuk Yıkama',
    rating: 5,
    text: 'L koltukta köpek kokusu sorunu vardı. Hem koltuk hem halı gibi görünen her şeyi tertemiz bıraktılar. Gün içinde gelip teslim ettiler.',
    initials: 'ZA',
    color: 'bg-teal-500',
  },
  {
    name: 'Emre Şahin',
    location: 'Pendik',
    date: 'Mart 2025',
    service: 'Petek Temizliği',
    rating: 5,
    text: '18 yıl demişler, gerçekten belli oluyor. Makineleri ve yöntemleri çok farklı. Herhangi bir marka yetkili servisinden çok daha iyi iş çıkardılar.',
    initials: 'EŞ',
    color: 'bg-rose-500',
  },
];

export default function Reviews() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) el.classList.add('opacity-100', 'translate-y-0'); },
      { threshold: 0.05 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="reviews" className="w-full bg-[#f8faf9] py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4">
        <div
          ref={ref}
          className="opacity-0 translate-y-8 transition-all duration-700"
        >
          {/* Header */}
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
            <div>
              <span className="inline-block text-emerald-600 font-semibold text-sm uppercase tracking-widest mb-3">
                Müşteri Yorumları
              </span>
              <h2
                className="text-3xl md:text-5xl font-extrabold text-[#1a1a1a] leading-tight"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                18 Yıldır Güvenilir Hizmet
              </h2>
            </div>
            <div className="flex items-center gap-3 bg-white border border-gray-100 rounded-2xl px-5 py-3">
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400" />
                  </span>
                ))}
              </div>
              <span className="font-bold text-[#1a1a1a] text-lg">5.0</span>
              <span className="text-gray-400 text-sm whitespace-nowrap">300+ yorum</span>
            </div>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {reviews.map((r) => (
              <div
                key={r.name}
                className="bg-white border border-gray-100 rounded-2xl p-6 flex flex-col hover:-translate-y-1 transition-transform duration-300"
              >
                {/* Top */}
                <div className="flex items-center gap-3 mb-4">
                  <div className={`w-11 h-11 flex items-center justify-center ${r.color} rounded-full text-white font-bold text-sm flex-shrink-0`}>
                    {r.initials}
                  </div>
                  <div>
                    <p className="font-bold text-[#1a1a1a] text-sm">{r.name}</p>
                    <p className="text-gray-400 text-xs flex items-center gap-1">
                      <span className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-map-pin-line" />
                      </span>
                      {r.location}
                    </p>
                  </div>
                  <div className="ml-auto flex gap-0.5">
                    {[...Array(r.rating)].map((_, i) => (
                      <span key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-star-fill text-amber-400 text-xs" />
                      </span>
                    ))}
                  </div>
                </div>

                {/* Service badge */}
                <span className="inline-block bg-emerald-50 text-emerald-700 text-xs font-semibold px-3 py-1 rounded-full mb-3 self-start">
                  {r.service}
                </span>

                {/* Text */}
                <p className="text-gray-600 text-sm leading-relaxed flex-1 mb-4">&ldquo;{r.text}&rdquo;</p>

                {/* Date */}
                <p className="text-gray-400 text-xs">{r.date}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
